import React, { Suspense } from 'react';
import Loader from '../components/Loader';
import { getRemoteConfig } from '../config/routeConfig';
import { getRemoteComponent as loadRemoteComponent } from '../utils/loadRemoteModule';
import { useNavigate } from 'react-router-dom';
import { useRemoteComponentStore } from '../context/RemoteComponentStoreContext';
import { NavigationItem } from '../interfaces/userContext';
import { RemoteComponentStoreContextProps } from 'interfaces/remoteContext';

interface RemoteBoxProps {
    path: string;
    navItem?: NavigationItem;
}

const RemoteBox: React.FC<RemoteBoxProps> = ({ path, navItem }) => {
    const {
        getSharedState: globalGetSharedState,
        setSharedStateValue: globalSetSharedStateValue,
        setSharedState: globalSetSharedState,
    } = useRemoteComponentStore();
    const navigate = useNavigate();
    console.log(globalSetSharedState)

    // Namespaced versions of getSharedState, setSharedStateValue, and setSharedState
    const productKey = navItem ? navItem.product : path;
    // Debugging logs
    const sharedStateKeys = globalGetSharedState('') ? Object.keys(globalGetSharedState('')) : [];
    console.log('Product Key:', productKey);
    console.log('Shared State Keys:', sharedStateKeys);

    // Fallback for undefined availableFilters
    const availableFilters = globalGetSharedState('availableFilters') || {};
    console.log('Available Filters:', availableFilters);

    const routeConfig = getRemoteConfig(path);
    if (routeConfig) {
        console.log('Getting remote config ', { routeConfig }, ', for path ', { path });

        const RemoteComponent = loadRemoteComponent(routeConfig) as React.ComponentType<Partial<RemoteComponentStoreContextProps>>;
        if (RemoteComponent) {
            return (
                <Suspense fallback={<Loader />}>
                    <RemoteComponent
                        getSharedState={(key: string) => globalGetSharedState(`${productKey}:${key}`) || {}}
                        setSharedStateValue={(key: string, value: any) => globalSetSharedStateValue(`${productKey}:${key}`, value)}
                        setSharedState={globalSetSharedState}
                    />
                </Suspense>
            );
        }
    } else {
        console.log('Route config not found!');
        navigate('/auth/deny');
        return null;
    }

    return null;
};

export default RemoteBox;